import BaseView from '../views/base-view';
import { Object3D } from 'three';

/**
 * Find the BaseView instance to which the given Object3D belongs or throw an
 * error if none is found.
 *
 * Note that if the given object is itself an instance of BaseView, then the
 * object itself is returned. If you prefer to receive the view enclosing the
 * view you have, then call this as `getParentView(this.parent)`.
 */
export const getParentView = (obj: Object3D): BaseView => {
    const view = getParentViewOrNull(obj);
    if(view) {
        return view;
    } else {
        throw new Error("Unable to locate parent view for Object3D");
    }
}

/**
 * Find a BaseView instance above the given object or return null.
 */
export const getParentViewOrNull = (obj: Object3D): BaseView | null => {
    let item: Object3D | null = obj;
    while(item != null) {
        if(item instanceof BaseView) {
            return item;
        } else {
            item = item.parent;
        }
    }
    return null;
}
